/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseProjectUserDtoPage } from '../../models/base-project-user-dto-page';

export interface ListProjectMembers$Params {
  id: string;
  memberId?: string | null;
  query?: string;
  roleIds?: Array<string>;
  userId?: string | null;
  excludeIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'memberId' | '-memberId' | 'firstName' | '-firstName' | 'lastName' | '-lastName' | 'email' | '-email' | 'color' | '-color' | 'memberships' | '-memberships'>;
}

export function listProjectMembers(http: HttpClient, rootUrl: string, params: ListProjectMembers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseProjectUserDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listProjectMembers.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('memberId', params.memberId, {});
    rb.query('query', params.query, {});
    rb.query('roleIds', params.roleIds, {});
    rb.query('userId', params.userId, {});
    rb.query('excludeIds', params.excludeIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseProjectUserDtoPage>;
    })
  );
}

listProjectMembers.PATH = '/v0/projects/{id}/members';
